import { AppRouteProps } from "@mzara/component";
import { MindMapNodeContainer } from "./containers/MindMapNodeContainer";

export const MindMapDetailsNodeRoutes: Array<AppRouteProps> = [
    {
        path: 'node/:nodeId',
        element: <MindMapNodeContainer />,
    },
]
